import { type FC, type InputHTMLAttributes } from 'react'

type Option = { label: string; value: string }

interface CheckboxGroupFieldProps {
  name: string
  label: string
  options: Option[]
  scrollable?: boolean
  hasError?: boolean
  errorId?: string
  inputProps?: Omit<InputHTMLAttributes<HTMLInputElement>, 'name' | 'type' | 'value'>
}

const CheckboxGroupField: FC<CheckboxGroupFieldProps> = ({
  name,
  label,
  options,
  scrollable = false,
  hasError = false,
  errorId,
  inputProps,
}) => (
  <fieldset>
    <legend className="font-semibold text-ink-800">{`${label} (Select all that apply)`}</legend>
    <div
      className={`bg-white flex flex-col rounded-md border-2 divide-y-2 divide-ink-400 ${
        scrollable ? 'max-h-64 overflow-y-auto' : ''
      } ${hasError ? 'border-red-600' : 'border-ink-400'}`}
    >
      {options.map((option) => (
        <label key={option.value} className="flex items-center p-4 cursor-pointer text-ink-600">
          <input
            {...inputProps}
            type="checkbox"
            name={name}
            value={option.value}
            aria-invalid={hasError || undefined}
            aria-describedby={hasError && errorId ? errorId : undefined}
            className="mr-4"
          />
          {option.label}
        </label>
      ))}
    </div>
  </fieldset>
)

export default CheckboxGroupField
